import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MainLayoutComponent } from './layout/main-layout/main-layout.component';
import { canActivate } from './core/guard/auth.guard';

const routes: Routes = [
  {
    path: 'about-download',
    loadComponent: () =>
      import('./pages/after-login-pages/about-download-v2/about-download-v2.component').then(
        (m) => m.AboutDownloadV2Component
      ),
  },
  {
    path: '',
    component: MainLayoutComponent,
    children: [
      {
        path: '',
        canActivate: [canActivate],
        loadChildren: () => import('./pages/after-login-pages/pages.module').then(
          m => m.PagesModule
        )
      }
    ]
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'top',
      initialNavigation: 'enabledBlocking'
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
